import { Checkbox } from '../Checkbox';
import { StyledQmarkCheckboxes } from './style';
import { useIntl } from 'react-intl';
import { EmarketFilterOptions } from 'types/FilterOptions';

interface Props {
  emarket: EmarketFilterOptions | undefined;
}

export const EmarketCheckbox = ({ emarket }: Props) => {
  const intl = useIntl();

  if (!emarket) {
    return null;
  }

  return (
    <StyledQmarkCheckboxes>
      <Checkbox
        itemClassName={'filter-single-checkbox'}
        name={'emarket'}
        options={[
          {
            label: intl.formatMessage({ id: `delivery.${emarket.label}` }),
            value: emarket.value,
          },
        ]}
      />
    </StyledQmarkCheckboxes>
  );
};
